(function () {
  const trackingExpiryMs = 30 * 60 * 1000;
  const pendingStorageKey = 'odsProductModalTrackingPending';
  const allowedFields = [
    'form_type',
    'form_id',
    'product_id',
    'product_handle',
    'product_title',
    'variant_id',
    'variant_sku',
    'variant_title',
    'product_vendor',
    'product_type',
    'product_url',
    'page_url',
    'modal_source',
    'competitor_price',
    'competitor_domain',
    'event_timestamp',
  ];

  function sanitizeText(value, maxLength = 200) {
    return String(value || '')
      .replace(/[\u0000-\u001f\u007f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength);
  }

  function getCleanUrl(value) {
    try {
      const url = new URL(value || window.location.href, window.location.origin);
      return `${url.origin}${url.pathname}`;
    } catch (error) {
      return window.location && window.location.pathname ? window.location.pathname : '';
    }
  }

  function getSafeTimestamp(value) {
    const timestamp = Number(value);
    return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : Date.now();
  }

  function sanitizePrice(value) {
    const cleaned = String(value || '').replace(/[^0-9.]/g, '');
    if (!cleaned) return undefined;
    const number = Number(cleaned);
    return Number.isFinite(number) && number >= 0 ? number : undefined;
  }

  function getDomainFromUrl(value) {
    const rawValue = sanitizeText(value, 500);
    if (!rawValue) return '';

    try {
      const url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(rawValue) ? rawValue : `https://${rawValue}`);
      return url.hostname.replace(/^www\./i, '').toLowerCase().slice(0, 120);
    } catch (error) {
      return '';
    }
  }

  function sanitizePayload(payload) {
    const safePayload = {};

    allowedFields.forEach((field) => {
      if (!Object.prototype.hasOwnProperty.call(payload || {}, field)) return;

      if (field === 'competitor_price') {
        const price = sanitizePrice(payload[field]);
        if (price !== undefined) safePayload[field] = price;
        return;
      }

      if (field === 'event_timestamp') {
        safePayload[field] = getSafeTimestamp(payload[field]);
        return;
      }

      if (field === 'page_url' || field === 'product_url') {
        const cleanUrl = getCleanUrl(payload[field]);
        if (cleanUrl) safePayload[field] = cleanUrl;
        return;
      }

      const textValue = sanitizeText(payload[field], field === 'product_title' ? 200 : 120);
      if (textValue) safePayload[field] = textValue;
    });

    return safePayload;
  }

  function publish(eventName, payload) {
    const safePayload = sanitizePayload(payload);
    const analytics = window.Shopify && window.Shopify.analytics;

    if (!analytics || typeof analytics.publish !== 'function') {
      if (window.ODS_PRODUCT_MODAL_TRACKING_DEBUG === true && window.console && typeof window.console.log === 'function') {
        window.console.log('ODS product modal event skipped', eventName, safePayload);
      }

      return false;
    }

    try {
      analytics.publish(eventName, safePayload);

      if (window.ODS_PRODUCT_MODAL_TRACKING_DEBUG === true && window.console && typeof window.console.log === 'function') {
        window.console.log('ODS product modal event', eventName, safePayload);
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function getPendingPayloads() {
    try {
      return JSON.parse(window.sessionStorage.getItem(pendingStorageKey) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function setPendingPayloads(payloads) {
    try {
      window.sessionStorage.setItem(pendingStorageKey, JSON.stringify(payloads));
    } catch (error) {
      return;
    }
  }

  function storePendingSubmission(formId, payload) {
    const safePayload = sanitizePayload({
      ...payload,
      form_id: formId || payload.form_id,
      event_timestamp: Date.now(),
    });

    if (!safePayload.form_id) return;

    const payloads = getPendingPayloads();
    payloads[safePayload.form_id] = safePayload;
    setPendingPayloads(payloads);
  }

  function takePendingSubmission(formId) {
    if (!formId) return null;

    const payloads = getPendingPayloads();
    const pendingPayload = sanitizePayload(payloads[formId] || {});
    const pendingTimestamp = Number(pendingPayload.event_timestamp);

    delete payloads[formId];
    setPendingPayloads(payloads);

    if (!pendingTimestamp || Date.now() - pendingTimestamp > trackingExpiryMs) return null;
    return pendingPayload;
  }

  function publishConfirmedSubmission(formId) {
    const pendingPayload = takePendingSubmission(formId);
    if (!pendingPayload || !pendingPayload.form_type) return false;

    const eventNames = {
      price_match: 'ods:price_match_submitted',
      product_question: 'ods:product_question_submitted',
    };
    const eventName = eventNames[pendingPayload.form_type];

    if (!eventName) {
      if (window.ODS_PRODUCT_MODAL_TRACKING_DEBUG === true && window.console && typeof window.console.warn === 'function') {
        window.console.warn('ODS product modal event skipped for unknown form_type', pendingPayload.form_type);
      }

      return false;
    }

    return publish(eventName, pendingPayload);
  }

  window.ODSProductModalTracking = {
    getDomainFromUrl,
    publish,
    publishConfirmedSubmission,
    sanitizePayload,
    sanitizePrice,
    storePendingSubmission,
  };
})();
